import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  structuredData?: object;
  keywords?: string;
}
export function SEO({
  title,
  description,
  canonical,
  ogType = 'website',
  ogImage = 'https://www.useflowsense.com/og-image.jpg',
  structuredData,
  keywords
}: SEOProps) {
  const fullTitle = title.includes('Flowsense') ? title : `${title} | Flowsense`;
  const url = canonical || `https://www.useflowsense.com${window.location.pathname}`;
  return <Helmet data-id="element-291">
      {/* Primary Meta Tags */}
      <title data-id="element-292">{fullTitle}</title>
      <meta name="title" content={fullTitle} data-id="element-293" />
      <meta name="description" content={description} data-id="element-294" />
      {keywords && <meta name="keywords" content={keywords} data-id="element-295" />}
      <link rel="canonical" href={url} data-id="element-296" />

      {/* Favicon */}
      <link rel="icon" type="image/svg+xml" href="/favicon.svg" data-id="element-297" />
      <link rel="alternate icon" href="/favicon.svg" data-id="element-298" />
      <link rel="mask-icon" href="/favicon.svg" color="#4F46E5" data-id="element-299" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-300" />
      <meta property="og:url" content={url} data-id="element-301" />
      <meta property="og:title" content={fullTitle} data-id="element-302" />
      <meta property="og:description" content={description} data-id="element-303" />
      <meta property="og:image" content={ogImage} data-id="element-304" />
      <meta property="og:site_name" content="Flowsense" data-id="element-305" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-306" />
      <meta property="twitter:url" content={url} data-id="element-307" />
      <meta property="twitter:title" content={fullTitle} data-id="element-308" />
      <meta property="twitter:description" content={description} data-id="element-309" />
      <meta property="twitter:image" content={ogImage} data-id="element-310" />

      {/* Article specific meta tags */}
      {ogType === 'article' && <>
          <meta property="article:publisher" content="Flowsense" data-id="element-311" />
          <meta property="article:section" content="Help & Support" data-id="element-312" />
          {keywords && <meta property="article:tag" content={keywords} data-id="element-313" />}
        </>}

      {/* Structured Data */}
      {structuredData && <script type="application/ld+json" data-id="element-314">
          {JSON.stringify(structuredData)}
        </script>}
    </Helmet>;
}